import ClearIcon from "@mui/icons-material/Clear";
import { Autocomplete, Box, CircularProgress, TextField } from "@mui/material";
import { debounce } from "lodash";
import { useState } from "react";
import { UseFormRegister } from "react-hook-form";
import type { IExhibitorList } from "src/content/modules/exhibitor/type/exhibitorType";
import { useGetQueryWithTotal } from "src/hooks/useGetQueryWithTotal";
// Define the Country type

const ExhibitorSelectFieldList = ({
	register,
	fieldName,
	label,
	hideCustomLabel,
	isRequired,
	mt,
	onChange,
	defaultValue,
}: {
	register?: UseFormRegister<any>;
	fieldName: string;
	label?: string;
	hideCustomLabel?: boolean;
	isRequired?: boolean;
	mt?: "0";
	onChange?: (e: number) => void;
	defaultValue?: {
		country_id: number;
		country_name: string;
	};
}) => {
	const [search, setSearch] = useState("");
	const { data, isLoading } = useGetQueryWithTotal<IExhibitorList[]>({
		endPoint: "/api/fair/member",
		queryKeys: ["Exhibitor"],
		params: {
			name: search,
		},
	});
	// Fetch country data from the API

	return (
		<Box sx={{ mt: mt ? 0 : 2 }}>
			{!hideCustomLabel && (
				<label>
					{label}{" "}
					{isRequired && <span style={{ color: "red" }}>*</span>}
				</label>
			)}

			<Autocomplete
				//defaultValue={{ user_fair_member_id: 69, user_fair_member_company_name:''} || null}
				options={data?.data || []}
				getOptionLabel={(option: IExhibitorList) =>
					option?.user_fair_member_company_name
				}
				onInputChange={debounce((_, value) => {
					setSearch(value);
				}, 300)}
				onChange={(_, value: IExhibitorList) => {
					register &&
						register(fieldName).onChange({
							target: {
								name: fieldName,
								value: value ? value.user_fair_member_id : "",
							},
						});
					if (value?.user_fair_member_id) {
						onChange && onChange(value?.user_fair_member_id);
					}
				}}
				isOptionEqualToValue={(option, value) =>
					option?.user_fair_member_id === value?.user_fair_member_id
				}
				loading={isLoading}
				clearIcon={
					<span
						onClick={() => {
							setSearch("");
						}}
					>
						<ClearIcon fontSize='small' />
					</span>
				}
				renderInput={(params) => (
					<TextField
						{...params}
						placeholder='Enter Exhibitor'
						required={isRequired}
						label={hideCustomLabel ? label : ""}
						variant='outlined'
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{isLoading ? (
										<CircularProgress
											color='inherit'
											size={20}
										/>
									) : null}
									{params.InputProps.endAdornment}
								</>
							),
						}}
					/>
				)}
			/>
		</Box>
	);
};

export default ExhibitorSelectFieldList;
